import { useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import type { UseQueryOptions } from '@trinity/chat-components';
import { useQueryWrapper } from '@trinity/chat-components';
import type { AxiosResponse } from 'axios';
import type { GetWorkspaceTranscript } from '@trinity/chat/api/interfaces/workspace.transcript';
import { useChatApiClient } from '@trinity/chat-components/containers/Chat/useApiClient.js';

type Data = GetWorkspaceTranscript.Response;
type QueryKey = readonly [string, ITranscriptId];

const buildQueryKey = (data: ITranscriptId): QueryKey => {
  return ['workspace-transcript', data];
};

export function useWorkspaceTranscriptQuery(
  data: ITranscriptId,
  options?: Omit<UseQueryOptions<Data, AxiosResponse, Data, QueryKey>, 'queryKey' | 'queryFn'>,
) {

  const apiClient = useChatApiClient();

  const query = useQueryWrapper({
    queryKey: buildQueryKey(data),
    queryFn: () => {
      return apiClient.workspacesTranscript.getWorkspaceTranscript({
        transcriptId: data.transcriptId,
      });
    },
    ...options,
  });

  return query;
}

export function useInvalidateWorkspaceTranscriptQuery() {
  const queryClient = useQueryClient();

  return useCallback((data: ITranscriptId) => {
    const queryKey = buildQueryKey(data);

    return queryClient.invalidateQueries({ queryKey });
  }, [queryClient]);
}